<template>
  <div class="session-header">
    <div class="session-header__left">
      <router-link
        :to="`/${$i18n.locale}/dashboard`"
        class="session-header__dashboard-link"
        >← {{ $t('appHeader.backToDashboard') }}</router-link
      >
    </div>
    <div class="session-header__center">
      <router-link to="dashboard">
        <img class="session-header__logo" :src="logoUrl" alt="Borna" />
      </router-link>
    </div>
    <div class="session-header__right"></div>
  </div>
</template>

<script>
import LogoImageUrl from '@/assets/header_logo.jpg'

export default {
  name: 'session-header',
  data() {
    return { logoUrl: LogoImageUrl }
  },
}
</script>

<style lang="scss" scoped>
.session-header {
  @include flex-container(row, space-between, center);
  flex: 1;

  @include header-child;

  & > * {
    flex-basis: 1px;
    flex-grow: 1;
  }

  &__left {
    text-align: left;
  }

  &__center {
    text-align: center;
  }

  &__right {
    text-align: right;
  }

  &__logo {
    width: 94px;
    height: 40px;
  }

  &__dashboard-link {
    text-decoration: none;
    color: $c-soft-black;
  }
}

html.is-rtl {
  .session-header {
    direction: ltr;
  }
}
</style>
